import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div ...attributes class=\"LSG-c-pikaday\">\n  {{yield}}\n</div>\n",{ moduleName: "sh-www/components/lsg/lsg-pikaday.hbs" })